/**
 * The welcome page's hand-off (ADR-036). The static page has no analytics of its own and no consent
 * to measure under, so it remembers which call to action the person pressed in the tab's own session
 * storage, and the app reports it once — after consent, never before — as one closed code. A value
 * that is not one of the codes is forgotten rather than reported: nothing here is free text.
 */
export const LANDING_CTA_KEY = 'bilal.landing_cta';
export const LANDING_CTAS = Object.freeze(['google', 'email', 'guest'] as const);
export type LandingCta = (typeof LANDING_CTAS)[number];

function sessionStorageOrNull(): Pick<Storage, 'getItem' | 'removeItem'> | null {
  try {
    return globalThis.sessionStorage;
  } catch {
    // A browser that refuses storage refuses the read too; there is nothing to report then.
    return null;
  }
}

/** Reads and forgets the remembered call to action; null when none, or when it is not a code. */
export function takeLandingCta(
  storage: Pick<Storage, 'getItem' | 'removeItem'> | null = sessionStorageOrNull(),
): LandingCta | null {
  if (storage === null) return null;
  try {
    const value = storage.getItem(LANDING_CTA_KEY);
    if (value === null) return null;
    storage.removeItem(LANDING_CTA_KEY);
    return LANDING_CTAS.find((cta) => cta === value) ?? null;
  } catch {
    return null;
  }
}
